
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"37","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M36.633 18.5c0-10.217-8.2-18.5-18.316-18.5C8.2 0 0 8.283 0 18.5c0 9.234 6.697 16.888 15.454 18.275V23.847h-4.651V18.5h4.65v-4.075c0-4.638 2.736-7.198 6.92-7.198 2.006 0 4.1.362 4.1.362v4.553h-2.309c-2.276 0-2.985 1.425-2.985 2.888v3.47h5.08l-.811 5.347h-4.269v12.928c8.757-1.387 15.454-9.041 15.454-18.275z","fill":"#FEFEFE"}})])
          )
        }
      }
    